const suppliers = {
  suppliers: "Suppliers",
  supplier: "Supplier",
  supplierName: "Supplier Name",
  supplierEmail: "Supplier Email",
  supplierRegistrationNumber: "Supplier Registration Number",
  supplierAccountInfo: "Supplier Account Info",
  supplierAccountHolderName: "Supplier Account Holder Name",
  supplierIBAN: "Supplier IBAN",
  supplierURL: "Supplier URL",
  onboarding_status: "Onboarding status",
  tax_id: `Tax ID`,
  power_of_attorney: `Power of Attorney`,
  acceptance_of_terms_and_conditions: `Acceptance of Terms and Conditions`,
  legal_representative_info: `Legal representative information`,
  certificates: `Certificates`,
  bank_account_ownership: `Bank account ownership`,
  compliance_with_social_security: `Compliance with social security`,
  compliance_with_tax_administration: `Compliance with tax administration`,
  last_month_payment_installment_of_civil_liability_insurance_policy: `Last month payment installment of civil liability insurance policy`,
  goods_and_services: `Goods and services`,
  other_conditions: `Other conditions`,
  address_is_required: `Address is required`,
  currency_is_required: `Currency is required`,
  currency: `Currency`,
  view_contract: `View contract`,
  supplier_contract_removed_successfully: `Contract deleted successfully`,
  delete_contract: `Delete contract`,
  delete_contract_warning: `Deleted contract cannot be recovered`,
  "One or more validations issue,Supplier must have a unique email address.":
    "Supplier must have a unique email address",
  "No Supplier Contract found.": "No Supplier Contract found",
  erp_code: `ERP code`,
  invite_status: `Invite status`,
  invite_sent: `Sent`,
  invite_not_sent: `Not sent`,
  portal_status: `Portal Status`,
  portal_status_not_invited: `Not Invited`,
  portal_status_pending_onboarding: `Pending Onboarding`,
  portal_status_finished_onboarding: `Finished Onboarding`,
  portal_status_onboarded: `Onboarded`,
  approval_needed: `Approval needed`,
  approved: `Approved`,
  rejected: `Rejected`,
  legal_document_expires_soon: `Legal Document Expires Soon`,
  legal_document_expired: `Legal Document Expired`,
  send_invite: `Send invite`,
  send_invite_confirmation: `Are you sure you want to send an invite to {{count}} supplier(s)?`,
  send_invite_subtitle: `Select pending suppliers to send them an onboarding invitation`,
  invite_sent_successfully: `Invite sent successfully`,
  invites_sent_successfully: `Invites sent successfully`,
  invite_failed: `Failed to send invite`,
  download_csv: `Download CSV`,
  export_csv_failed: `Failed to export CSV`,
  no_pending_suppliers: `All suppliers have completed onboarding`,
  loading_suppliers: `Loading suppliers...`,
  select_all: `Select all`,
  selected: `selected`,
  sending: `Sending...`,
  companies: `Customer Companies`,
  select_all_companies: `Select All`,
  add_supplier_information: `Add Supplier Information`,
  edit_supplier_information: `Edit Supplier Information`,
  view_supplier_information: `View Supplier Information`,
  fill_in_the_vendor_details: `Fill in the vendor details`,
  update_the_vendor_details: `Update the vendor details`,
  view_vendor_details: `View vendor details`,
  invite_your_supplier_to_supplier_portal: `Invite your supplier to supplier portal`,
  basic_information: `Basic Information`,
  bank_information: `Bank Information`,
  address_information: `Address Information`,
  locality: `Locality`,
  region: `Region`,
  mandatory: `Mandatory`,
  mandatory_for_supplier: `Mandatory`,
  delete_document: `Delete document`,
  this_action_cannot_be_undone: `This action cannot be undone`,
  vendor_company_name: `Vendor Company name`,
  vendor_company_id: `Vendor Company ID`,
  vendor_email: `Vendor email`,
  enter_vendor_company_name: `Enter Vendor Company name`,
  enter_vendor_company_id: `Enter Vendor Company ID`,
  enter_company_id: `Enter Company ID`,
  enter_email: `Enter email`,
  select_a_currency: `Select a Currency`,
  logo_url: `Logo URL`,
  enter_logo_url: `Enter Logo URL`,
  customer_companies: `Customer companies`,
  select_customer_companies: `Select Customer companies`,
  enter_account_holder_name: `Enter Account holder name`,
  enter_iban: `Enter IBAN`,
  swift_bic_code: `Swift / BIC code`,
  enter_swift_bic_code: `Enter Swift / BIC code`,
  enter_address: `Enter Address`,
  enter_street: `Enter Street`,
  enter_street_number: `Enter Street number`,
  enter_locality: `Enter Locality`,
  enter_region: `Enter Region`,
  enter_zip_code: `Enter Zip Code`,
  enter_fax_number: `Enter Fax number`,
  enter_country: `Enter Country`,
  enter_contact_number: `Enter Contact Number`,
  onboarding_template: `Onboarding Template`,
  onboarding_template_description: `An onboarding template specifies the document groups invited supplier must submit`,
  select_an_onboarding_template: `Select an Onboarding Template`,
  no_template_selected_hint: `no template selected`,
  approver_name: `Approver Name`,
  select_approver: `Select Approver`,
  approver_is_required: `Approver is required`,
  assignment_reason: `Approver Reason`,
  enter_assignment_reason: `Enter approver reason`,
  assignment_reason_is_required: `Approver reason is required`,
  supported_documents: `Supported Documents`,
  add_supported_document: `Add supported document`,
  expires_on: `Expires on`,
  document_expired_on: `Document expired on`,
  document_not_configured_for_group: `This document is not configured for the selected group`,
  upload_document: `Upload document`,
  upload_x_document: `Upload {{name}} document`,
  update_supplier_before_uploading: `Update the supplier first, then upload this document`,
  other_tab: `Other`,
  po_tags_and_patterns: `PO Tags & Patterns`,
  po_tags_and_patterns_hint: `Add PO tags or patterns used to match purchase orders`,
  tags_and_patterns_placeholder: `Type a tag or pattern and press Enter`,
  service_tags_and_patterns: `Service Tags & Patterns`,
  service_tags_and_patterns_hint: `Add service tags or patterns used to match services`,
  remove_group_documents_to_change_template: `Remove the attached documents first to change the template`,
  onboarding_template_locked_after_completion: `Onboarding template cannot be changed once the supplier onboarding is completed`,
  upload_and_manage_document: `Upload and manage the document`,
  document_name_is_required: `Document name is required`,
  set_document_expiry: `Set document expiry`,
  expiry_date: `Expiry Date`,
  expiry_date_required: `Expiry date is required`,
  upload_new: `Upload new`,
  save_document: `Save document`,
  document_updated_successfully: `Document saved successfully`,
  reopen_supplier_to_add_documents: `Supplier created. Reopen it to add the documents.`,
  supplier_created_some_documents_failed: `Supplier created, but {{count}} document(s) failed to upload`,
  supplier_created_and_invited: `Supplier created and invite sent successfully`,
  supplier_created_invite_failed: `Supplier created, but sending the invite failed`,
  add_and_send_invite: `Add & Send Invite`,
  failed_to_load_onboarding_templates: `Failed to load onboarding templates`,
  failed_to_load_template_groups: `Failed to load template document groups`,
  no_permissions_to_view_template: `No permissions to view template`,
  png_jpeg_pdf_files_accepted_only: `PNG, JPEG, PDF files accepted only`,
  error_fetching_documents: `Something went wrong while fetching the supplier`,
  sections: {
    overview: "Overview",
    banking: "Banking",
    documents: "Documents",
    terms: "Terms",
    vendor_classification: "Vendor Classification",
    service_documents: "Service & Documents",
    certificates_tax_files: "Certificates & Tax Files",
    accounting_contact: "Accounting Contact",
    primary_bank_account: "Primary Bank Account",
    additional_bank_account: "Additional Bank Account",
    address_info: "Address Info",
  },
  payment_term: `Payment Term`,
  payment_method: `Payment Method`,
  select_payment_term: `Select a payment term`,
  select_payment_method: `Select a payment method`,
};
export default suppliers;
